import React from 'react';
import '../style.css';

const Video = () => {
  const videos = [
    {
      id: 1,
       youtubeId: "vk1knfGdFKU", // YouTube video ID
      duration: "4:15"
    },
    {
      id: 2,
      youtubeId: "QpSxiBYISKk", // YouTube video ID
      duration: "3:20"
    },
    {
      id: 3,
      youtubeId: "caA6PePqX-4", // YouTube video ID
      duration: "2:45"
    },
  ];

  return (
    <div className="rvg-main">
      <div className="rvg-grid">
        {videos.map((video) => (
          <div key={video.id} className="rvg-item">
            <div className="rvg-thumbnail">
              <img 
                src={`https://img.youtube.com/vi/${video.youtubeId}/maxresdefault.jpg`} 
                alt="" 
                className="rvg-img"
                onError={(e) => {
                  // अगर HD thumbnail नहीं मिले तो default use करो
                  e.target.src = `https://img.youtube.com/vi/${video.youtubeId}/0.jpg`;
                }}
              />
              <div className="rvg-play-btn">
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                  <circle cx="25" cy="25" r="25" fill="white" fillOpacity="0.9"/>
                  <path d="M20 15L35 25L20 35V15Z" fill="#4f46e5"/>
                </svg>
              </div>
              <div className="rvg-duration">{video.duration}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Video;